import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import BootstrapVue from 'bootstrap-vue'

import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
import A11yDialog from 'vue-a11y-dialog'
import 'vue-good-table/dist/vue-good-table.css'
import VueNumerals from 'vue-numerals'
import 'vue-search-select/dist/VueSearchSelect.css'
import 'vue-loaders/dist/vue-loaders.css'
import VueLoaders from 'vue-loaders'
import VueKonva from 'vue-konva'
import VueHtmlToPaper from 'vue-html-to-paper'
import IdleVue from 'idle-vue'
//import vuetify from '@/plugins/vuetify'

import VueAWN from 'vue-awesome-notifications'
import Print from 'vue-print-plugin'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueMobileDetection from 'vue-mobile-detection'
import VueModalTor from 'vue-modaltor/dist/vue-modaltor.common.js'
import 'vue-modaltor/dist/vue-modaltor.css'
import Toasted from 'vue-toasted'
import VueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(VueSmoothScroll)
Vue.config.silent = true

// import {
//   encode,
//   decode
// } from 'node-base64-image';

Vue.use(Toasted)

// include the default style

// Tell Vue to install the plugin.
const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 3600000, // 3600 seconds / 1 hour
  startAtIdle: false,
})
Vue.use(VueAWN, VueHtmlToPaper, Print)

// Vue.use(encode, decode)

Vue.use(VueKonva)
Vue.use(VueModalTor)

Vue.use(VueLoaders)

Vue.use(VueNumerals, {
  locale: 'en',
})
// Don't warn about using the dev version of Vue in development
Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.use(BootstrapVue)
Vue.use(A11yDialog)
Vue.use(VueMobileDetection)

const app = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

// If running inside Cypress
if (window.Cypress) {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`
  window.__app__ = app
}
